import Api from './api.service'

import Configuration from '@/configuration';
const baseURL = Configuration.value('apiFrontend')
const baseAdminURL = Configuration.value('apiBackend')

export default {
  getAll(params) {
    return Api().get(`${baseAdminURL}/sale`, { params })
  },
  get() {
    return Api().get(`${baseURL}/sale`)
  },
  getById(id) {
    return Api().get(`${baseAdminURL}/sale/${id}`)
  },
  delete(id) {
    return Api().delete(`${baseAdminURL}/sale/${id}`)
  },
  getStats(params) {
    return Api().get(`${baseAdminURL}/statistic`, params)
  },
  getAmountPerMonth() {
    return Api().get(`${baseAdminURL}/statistic/amount-per-month`)
  },
  getPending(query) {
    return Api().get(`${baseAdminURL}/sale/pending`, { params: query })
  },
  countByRange(range) {
    return Api().get(`${baseAdminURL}/sale/count-range`, { params: range })
  },
  update(id, payload) {
    return Api().post(`${baseAdminURL}/sale/${id}`, payload)
  },
  getVehicleCount(query) {
    return Api().get(`${baseURL}/statistic`, { params: query })
  },
  getOpenInvoices(query) {
    return Api().get(`${baseAdminURL}/sale/open-invoices`, { params: query })
  }
}
